// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
   display: flex;
   flex-direction: column;
   justify-content: center;
}

.preview {
   margin-bottom: 15px;
   display: flex;
   flex-direction: row;

}

.image-preview {
   height: unset;
   max-width: 100%;
   max-height:100%;
   border-radius: inherit;
}

.delete {
   cursor: pointer;
   color: white;
   border-radius: 0px;
}

.image-preview-thumbnail {
   width: auto;
   height: auto;
   max-width: 50%;
   max-height: 250px;
   background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLImageUploader/ECLImageUploader.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;AAC1B;;AAEA;GACG,mBAAmB;GACnB,aAAa;GACb,mBAAmB;;AAEtB;;AAEA;GACG,aAAa;GACb,eAAe;GACf,eAAe;GACf,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,cAAc;GACd,iBAAiB;GACjB,uBAAuB;AAC1B","sourcesContent":[".container {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n}\r\n\r\n.preview {\r\n   margin-bottom: 15px;\r\n   display: flex;\r\n   flex-direction: row;\r\n\r\n}\r\n\r\n.image-preview {\r\n   height: unset;\r\n   max-width: 100%;\r\n   max-height:100%;\r\n   border-radius: inherit;\r\n}\r\n\r\n.delete {\r\n   cursor: pointer;\r\n   color: white;\r\n   border-radius: 0px;\r\n}\r\n\r\n.image-preview-thumbnail {\r\n   width: auto;\r\n   height: auto;\r\n   max-width: 50%;\r\n   max-height: 250px;\r\n   background: transparent;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
